/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProcessInputs */

const en_process = /** @type {(inputs: ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process`)
};

const es_process = /** @type {(inputs: ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceso`)
};

/**
* | output |
* | --- |
* | "Process" |
*
* @param {ProcessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const process = /** @type {((inputs?: ProcessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProcessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_process(inputs)
	return es_process(inputs)
});